import { LoadPatientByCpf } from 'domain/usecases/patient/load-patient-by-cpf'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientByCpf implements LoadPatientByCpf {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    cpf: string,
    params?: LoadPatientByCpf.Params
  ): Promise<LoadPatientByCpf.Model> {
    return this.patientRepository.loadPatientByCpf(cpf, params)
  }
}

export type LoadPatientByCpfModel = LoadPatientByCpf.Model
